import * as React from 'react';
import { Box } from '@mui/material';
import { withStyles } from '../../settings/styles';
import { connect } from 'react-redux';
import { AppState } from '../../model/reducers';
import { ThunkDispatch } from 'redux-thunk';
import { NavigationPath, NavigationTab, NavigationTabs } from '../../model/navigation/types';
import { WithTranslation, withTranslation } from 'react-i18next';

// ------------ State & Props ------------  //

interface State 
{

};

interface LocalProps extends WithTranslation
{
    tabs: NavigationTabs;
    link: NavigationPath;
}

interface StateProps
{
    tab: NavigationTab;
}

interface DispatchProps
{

}

type Props = LocalProps & StateProps & DispatchProps;

// ----------------- Class -----------------  //

class PageGroup extends React.Component<Props, State> 
{
    constructor(props: any)
    {
        super(props);
        this.state = {};
    }

    render () 
    {
        const PageComponent = this.props.tab.component;
        return (
            <Box sx={{width: "100%", height: "100%"}}>
                <PageComponent {...this.props} />
            </Box>
        );
    }
}

// ----------------- Export -----------------  //

const mapStateToProps = (state: AppState, props: LocalProps): StateProps => ({
    tab: props.tabs[state.navigation.subPages[props.link.id].currentTab ?? props.link.tabs[0]]
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{},{},any>, props: LocalProps): DispatchProps => ({
});

export default withStyles(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PageGroup)));

// ------------------------------------------  //